import { Component, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { AmdScrollService } from '../utilities/scroll/scroll.service';
export class AmdAppContainerComponent {
    /**
     * @param {?} document
     * @param {?} renderer
     * @param {?} amdScrollService
     */
    constructor(document, renderer, amdScrollService) {
        this.document = document;
        this.renderer = renderer;
        this.amdScrollService = amdScrollService;
        this.renderer.listen('window', 'scroll', this.onWindowScroll.bind(this));
    }
    /**
     * @return {?}
     */
    onWindowScroll() {
        this.amdScrollService.$windowScroll.next(this.getScrollTop());
    }
    /**
     * @return {?}
     */
    getScrollTop() {
        return this.document.documentElement.scrollTop || this.document.body.scrollTop;
    }
}
AmdAppContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-app-container',
                template: "<div class=\"amd-app-container\"> <ng-content></ng-content> </div>"
            },] },
];
/**
 * @nocollapse
 */
AmdAppContainerComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
    { type: Renderer2, },
    { type: AmdScrollService, },
];
function AmdAppContainerComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdAppContainerComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdAppContainerComponent.ctorParameters;
    /** @type {?} */
    AmdAppContainerComponent.prototype.document;
    /** @type {?} */
    AmdAppContainerComponent.prototype.renderer;
    /** @type {?} */
    AmdAppContainerComponent.prototype.amdScrollService;
}
//# sourceMappingURL=app-container.component.js.map
//# sourceMappingURL=app-container.component.js.map
